import Business from '@constants/Business'
import offerLink from '@utils/links/offerLink'
import offerLinkBuy from '@utils/links/offerLinkBuy'

export default function offerSchemaLink (buy, offer) {
    return Business.host + (buy
        ? offerLinkBuy(offer)
        : offerLink(offer))
}